export const orderInfoAction= (data) => { 
    return {
       type: data.type,
       data: data.data
    }
 }